import { z } from "zod";

import { WebhookStatusSchema } from "./WebhookStatus.schema";

/**
 * Common webhook settings
 */
export const WebhookSettingsSchema = z.object({
  /** Current webhook status */
  status: WebhookStatusSchema,
  /** Registered webhook URL */
  url: z.string().optional(),
  /** When webhook was registered (ISO date) */
  registeredAt: z.string().optional(),
  /** Secret token for webhook validation (Telegram X-Telegram-Bot-Api-Secret-Token) */
  secretToken: z.string().optional(),
  /** Error message if registration failed */
  error: z.string().optional(),
  /** When the error occurred (ISO date) */
  errorAt: z.string().optional()
});
export type WebhookSettings = z.infer<typeof WebhookSettingsSchema>;
